import React, { useRef, useState, useEffect } from "react";
import { EditSurveyFooterBackground, EditSurveyHeaderBackground } from "../../redux/slice/SurveySlice/SurveySlice";
import { useDispatch } from "react-redux";

const ImageUpload = ({ headerBackgroundPath, footerBackgroundPath }) => {
  const fileInputRef = useRef(null);
  const [file, setFile] = useState(null);
  const [footerFile, setFooterFile] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    if (headerBackgroundPath) {
      setFile(headerBackgroundPath);
    }
  }, [headerBackgroundPath]);

  useEffect(() => {
    if (footerBackgroundPath) {
      setFooterFile(footerBackgroundPath);
    }
  }, [footerBackgroundPath]);

  const handleHeaderFileChange = (e) => {
    const fileInput = fileInputRef.current;
    const file = e.target.files[0];

    const validTypes = ['image/jpeg', 'image/png', 'image/jpg'];
    if (file && !validTypes.includes(file.type)) {
      alert('Lütfen sadece JPG, JPEG veya PNG dosyası yükleyin.');
      fileInput.value = '';
      return;
    }

    const maxSize = 50 * 1024 * 1024;
    if (file && file.size > maxSize) {
      alert('Dosya boyutu 50MB\'yi geçemez.');
      fileInput.value = '';
      return;
    }

    if (file) {
      setFile(URL.createObjectURL(file));
      dispatch(EditSurveyHeaderBackground(file));
    }
  };

  const handleFooterFileChange = (e) => {
    const fileInput = fileInputRef.current;
    const file = e.target.files[0];

    const validTypes = ['image/jpeg', 'image/png', 'image/jpg'];
    if (file && !validTypes.includes(file.type)) {
      alert('Lütfen sadece JPG, JPEG veya PNG dosyası yükleyin.');
      fileInput.value = '';
      return;
    }

    const maxSize = 50 * 1024 * 1024;
    if (file && file.size > maxSize) {
      alert('Dosya boyutu 50MB\'yi geçemez.');
      fileInput.value = '';
      return;
    }

    if (file) {
      setFooterFile(URL.createObjectURL(file));
      dispatch(EditSurveyFooterBackground(file));
    }
  };

  return (
    <div className="relative z-0 mb-8 w-full group">
      {/* Header Resim Gösterimi */}
      {file && (
        <div className="mb-4">
          <div className="relative w-32 h-32 border-2 border-gray-300 rounded-lg overflow-visible"> {/* overflow-visible eklendi */}
            <img
              src={file}
              alt="Header Background"
              className="object-cover w-full h-full rounded-lg"
            />
            <button
              type="button"
              onClick={() => {
                setFile(null);
                fileInputRef.current.value = '';
              }}
              className="absolute top-0 right-0 bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs font-bold border-2 border-white hover:bg-red-600 transition-colors duration-300 transform translate-x-1/2 -translate-y-1/2"
            >
              X
            </button>
          </div>
        </div>
      )}


      <label className="block text-sm text-gray-500 mb-2">
        Anket Üst Resim (Zorunlu Değildir)
      </label>
      <input
        type="file"
        accept="image/*"
        ref={fileInputRef}
        className="block w-full px-4 py-3 text-sm text-gray-700 bg-white border-2 border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-blue-700 hover:file:bg-blue-100 transition duration-300"
        onChange={handleHeaderFileChange}
      />

      {/* Footer Resim Gösterimi */}
      {footerFile && (
        <div className="mt-4 mb-4">
          <div className="relative w-32 h-32 border-2 border-gray-300 rounded-lg overflow-visible">
            <img
              src={footerFile}
              alt="Footer Background"
              className="object-cover w-full h-full rounded-lg"
            />
            <button
              type="button"
              onClick={() => {
                setFooterFile(null);
                fileInputRef.current.value = '';
              }}
              className="absolute top-0 right-0 bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs font-bold border-2 border-white hover:bg-red-600 transition-colors duration-300 transform translate-x-1/2 -translate-y-1/2"
            >
              X
            </button>
          </div>
        </div>
      )}


      <label className="block text-sm text-gray-500 mb-2 mt-3">
        Anket Alt Resim (Zorunlu Değildir)
      </label>
      <input
        type="file"
        accept="image/*"
        ref={fileInputRef}
        className="block w-full px-4 py-3 text-sm text-gray-700 bg-white border-2 border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-blue-700 hover:file:bg-blue-100 transition duration-300"
        onChange={handleFooterFileChange}
      />
    </div>
  );
};

export default ImageUpload;
